module.exports =  {
    templateUrl: '/partials/components/SearchFormTemplate.tpl?' + __webpack_hash__,
    controller: require( '../controllers/SearchFormController' ),
    controllerAs: 'searchFormCtrl',
    bindings: {
        autocompleteEnabled: '<'
    }
};